export default __webpack_public_path__ + "static/media/heroHome.76d5b9ce.jpeg";